import { render, staticRenderFns } from "./LiteratureLayout.vue?vue&type=template&id=fb5d2994&scoped=true&"
import script from "./LiteratureLayout.vue?vue&type=script&lang=js&"
export * from "./LiteratureLayout.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureLayout.vue?vue&type=style&index=0&id=fb5d2994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d2994",
  null
  
)

export default component.exports